import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { logOut, auth } from '../services/firebase';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      await logOut();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-slate-800 border-b border-slate-700">
      <div className="container-custom">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/dashboard" className="text-2xl font-bold gradient-text">
            AIMentor
          </Link>

          {/* Navigation Links */}
          <div className="hidden md:flex items-center gap-6">
            <Link
              to="/dashboard"
              className={`transition ${
                isActive('/dashboard')
                  ? 'text-indigo-400 font-semibold'
                  : 'text-slate-300 hover:text-white'
              }`}
            >
              Dashboard
            </Link>
            <Link
              to="/tutor"
              className={`transition ${
                isActive('/tutor')
                  ? 'text-indigo-400 font-semibold'
                  : 'text-slate-300 hover:text-white'
              }`}
            >
              AI Tutor
            </Link>
            <Link
              to="/quiz"
              className={`transition ${
                isActive('/quiz')
                  ? 'text-indigo-400 font-semibold'
                  : 'text-slate-300 hover:text-white'
              }`}
            >
              Quiz
            </Link>
          </div>

          {/* User Menu */}
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-3">
              <img
                src={auth.currentUser?.photoURL || '/default-avatar.png'}
                alt="Profile"
                className="w-8 h-8 rounded-full"
              />
              <span className="text-sm text-slate-300">
                {auth.currentUser?.displayName}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="text-slate-400 hover:text-white transition"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;